import { render, staticRenderFns } from "./box-5-unit-5.vue?vue&type=template&id=06b9039e&scoped=true&"
import script from "./box-5-unit-5.vue?vue&type=script&lang=ts&"
export * from "./box-5-unit-5.vue?vue&type=script&lang=ts&"
import style0 from "./box-5-unit-5.vue?vue&type=style&index=0&id=06b9039e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9039e",
  null
  
)

export default component.exports